(function () {
  'use strict';

  var CONFIG = null;
  var focusBeforeModal = null;
  var activeBundleType = null;

  function getConfig() {
    if (CONFIG) return CONFIG;
    var el = document.getElementById('yazli-bundle-config');
    if (!el) return null;
    try {
      CONFIG = JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[yazli-bundles] invalid config', e);
      CONFIG = null;
    }
    return CONFIG;
  }

  function routesRoot() {
    var cfg = getConfig();
    if (cfg && cfg.routes && cfg.routes.root) return cfg.routes.root;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (window.routes && window.routes.root) return window.routes.root;
    return '/';
  }

  function cartAddUrl() {
    // Never use locale-prefixed /ar/cart/add — Ajax API 404s; root /cart/add.js works EN+AR
    return '/cart/add.js';
  }

  function cartChangeUrl() {
    return '/cart/change.js';
  }

  function cartJsUrl() {
    return '/cart.js';
  }

  function qs(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function getModal() {
    return document.getElementById('yazli-bundle-modal');
  }

  function syncModalForBundle(bundleType) {
    var modal = getModal();
    if (!modal) return;
    var type = bundleType || 'follow';
    if (type !== 'follow' && type !== 'amaze' && type !== 'complete') type = 'follow';

    var hero = modal.querySelector('[data-yazli-bm-hero]');
    var title = modal.querySelector('[data-yazli-bm-title]');
    var text = modal.querySelector('[data-yazli-bm-text]');
    var heroSrc = modal.getAttribute('data-hero-' + type);
    var titleText = modal.getAttribute('data-title-' + type);
    var leadText = modal.getAttribute('data-text-' + type);

    if (hero && heroSrc) hero.src = heroSrc;
    if (title && titleText) title.textContent = titleText;
    if (text && leadText) text.textContent = leadText;

    modal.querySelectorAll('[data-prices-for]').forEach(function (el) {
      var match = el.getAttribute('data-prices-for') === type;
      el.hidden = !match;
      el.classList.toggle('is-active', match);
    });

    modal.querySelectorAll('[data-thumb-for]').forEach(function (el) {
      var match = el.getAttribute('data-thumb-for') === type;
      el.hidden = !match;
      el.classList.toggle('is-active', match);
    });

    modal.querySelectorAll('[data-title-for]').forEach(function (el) {
      var match = el.getAttribute('data-title-for') === type;
      el.hidden = !match;
      el.classList.toggle('is-active', match);
    });

    modal.querySelectorAll('[data-desc-for]').forEach(function (el) {
      var match = el.getAttribute('data-desc-for') === type;
      el.hidden = !match;
      el.classList.toggle('is-active', match);
    });

    modal.querySelectorAll('[data-yazli-perfume-select]').forEach(function (btn) {
      var variantId = btn.getAttribute('data-variant-' + type) || '';
      var available = btn.getAttribute('data-available-' + type) === 'true';
      var ok = Boolean(variantId) && available;
      btn.disabled = !ok;
      btn.classList.toggle('is-disabled', !ok);
      btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      btn.classList.remove('is-loading');
    });

    var err = modal.querySelector('[data-yazli-bm-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
  }

  function openModal(bundleType) {
    var modal = getModal();
    if (!modal) return;
    activeBundleType = bundleType || 'follow';
    syncModalForBundle(activeBundleType);
    focusBeforeModal = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('yazli-bm-open');
    var dialog = modal.querySelector('.yazli-bm__dialog');
    var closeBtn = modal.querySelector('[data-yazli-bundle-close]');
    window.setTimeout(function () {
      (closeBtn || dialog || modal).focus();
    }, 10);
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yazli-bm-open');
    window.setTimeout(function () {
      modal.hidden = true;
    }, 280);
    if (focusBeforeModal && typeof focusBeforeModal.focus === 'function') {
      focusBeforeModal.focus();
    }
    activeBundleType = null;
  }

  function perfumeUrl(baseUrl, perfume, bundleType) {
    var url;
    try {
      url = new URL(baseUrl, window.location.origin);
    } catch (e) {
      url = new URL(routesRoot().replace(/\/?$/, '/') + 'products/' + perfume, window.location.origin);
    }
    url.searchParams.set('bundle', bundleType || 'follow');
    url.hash = 'bundle-options';
    return url.pathname + url.search + url.hash;
  }

  function showModalError(message) {
    var modal = getModal();
    if (!modal) return;
    var err = modal.querySelector('[data-yazli-bm-error]');
    if (!err) return;
    err.textContent = message || '';
    err.hidden = !message;
  }

  function addBundleFromModal(btn) {
    if (!btn || !activeBundleType || btn.disabled) return;
    var type = activeBundleType;
    var variantId = btn.getAttribute('data-variant-' + type);
    if (!variantId) {
      var cfg = getConfig();
      showModalError((cfg && cfg.i18n && cfg.i18n.priceUnavailable) || 'Unavailable');
      return;
    }

    var cfg = getConfig();
    var labelEl = btn.querySelector('.yazli-bm__add-label');
    var original = labelEl ? labelEl.textContent : '';
    var adding = (cfg && cfg.i18n && cfg.i18n.adding) || 'Adding…';

    btn.classList.add('is-loading');
    btn.disabled = true;
    if (labelEl) labelEl.textContent = adding;
    showModalError('');

    addVariant(variantId, 1)
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        closeModal();
        refreshCartDrawer(cart);
      })
      .catch(function (err) {
        console.error('[yazli-bundles] modal ATC', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (labelEl) labelEl.textContent = original;
        showModalError(
          (err && err.message) || (cfg && cfg.i18n && cfg.i18n.error) || 'Error'
        );
      });
  }

  function refreshCartDrawer(cart) {
    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart(cart || undefined);
    } else if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.getCart === 'function') {
      window.Shopify.getCart(function (c) {
        if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
          window.sharedFunctions.updateSidebarCart(c);
        }
      });
    }
    document.body.classList.add('cart-sidebar-show');
  }

  function addVariant(variantId, quantity) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity || 1 }]
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Add to cart failed');
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  function changeLine(key, quantity) {
    return fetch(cartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && data.message) || 'Cart update failed');
        return data;
      });
    });
  }

  function fetchCart() {
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function warnBadCompare(type, price, compare) {
    if (compare != null && price != null && Number(compare) <= Number(price)) {
      console.warn('[yazli-bundles] compare_at_price <= price for', type, { price: price, compare: compare });
    }
  }

  /* ——— Homepage modal ——— */
  function initTeaser() {
    document.querySelectorAll('[data-yazli-bundle-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-bundle-type') || 'follow');
      });
    });

    var modal = getModal();
    if (!modal) return;

    modal.querySelectorAll('[data-yazli-bundle-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.querySelectorAll('[data-yazli-perfume-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addBundleFromModal(btn);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        e.preventDefault();
        closeModal();
      }
    });
  }

  function formatMoneyCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var formatted = Shopify.formatMoney(n, window.money_format || '{{amount}}');
      var tmp = document.createElement('div');
      tmp.innerHTML = formatted;
      return (tmp.textContent || formatted || '').trim();
    }
    return 'Dhs. ' + (n / 100).toFixed(2);
  }

  function setMoneyText(el, text) {
    if (!el) return;
    var nested = el.querySelector('.money');
    if (nested) nested.textContent = text;
    else el.textContent = text;
  }

  /* Keep sticky ATC footer price / variant in sync with PDP bundle choice */
  function syncStickyFromBundleCard(card) {
    var sticky = document.querySelector('[data-sticky-add-to-cart]');
    if (!sticky || !card) return;

    var price = card.getAttribute('data-price');
    var compare = card.getAttribute('data-compare');
    var variantId = card.getAttribute('data-variant-id');
    var nameEl = card.querySelector('.yazli-bo__name');
    var name = nameEl ? nameEl.textContent.trim() : '';

    var priceText = formatMoneyCents(price);
    var compareNum = Number(compare);
    var priceNum = Number(price);
    var hasCompare = isFinite(compareNum) && isFinite(priceNum) && compareNum > priceNum;
    var compareText = hasCompare ? formatMoneyCents(compareNum) : '';

    sticky.querySelectorAll('.sticky-price').forEach(function (wrap) {
      var sub = wrap.querySelector('.money-subtotal');
      if (sub && priceText) setMoneyText(sub, priceText);

      var compareEl = wrap.querySelector('.money-compare-price');
      if (hasCompare) {
        wrap.classList.add('has-compare-price');
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'money-compare-price';
          if (sub && sub.parentNode === wrap) wrap.insertBefore(compareEl, sub);
          else wrap.prepend(compareEl);
        }
        compareEl.setAttribute('data-compare-price', String(compareNum));
        setMoneyText(compareEl, compareText);
        compareEl.hidden = false;
        compareEl.style.display = '';
      } else if (compareEl) {
        compareEl.hidden = true;
        compareEl.style.display = 'none';
        wrap.classList.remove('has-compare-price');
      }
    });

    // Mobile sticky duplicate price block
    sticky.querySelectorAll('.sticky-info .money-subtotal').forEach(function (el) {
      if (priceText) setMoneyText(el, priceText);
    });

    if (variantId) {
      sticky.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
        input.value = variantId;
      });
    }

    if (isFinite(priceNum)) {
      sticky.querySelectorAll('input.quantity__input[data-price], input[name="quantity"][data-price]').forEach(function (input) {
        input.setAttribute('data-price', String(priceNum));
      });
    }

    if (name) {
      sticky.querySelectorAll('.sticky-title').forEach(function (el) {
        el.textContent = name;
      });
    }
  }

  /* ——— PDP options ——— */
  function initPdp() {
    var root = document.querySelector('[data-yazli-bundle-options]');
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-yazli-bundle-option]'));
    var atc = root.querySelector('[data-yazli-bundle-atc]');
    var errorEl = root.querySelector('[data-yazli-bundle-error]');
    var selected = null;
    var cfg = getConfig();

    cards.forEach(function (card) {
      warnBadCompare(
        card.getAttribute('data-bundle-type'),
        card.getAttribute('data-price'),
        card.getAttribute('data-compare')
      );
    });

    function selectCard(card) {
      if (!card || card.disabled) return;
      selected = card;
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (atc) {
        var hasVariant = Boolean(card.getAttribute('data-variant-id'));
        atc.disabled = !hasVariant;
        var isSolo = card.getAttribute('data-bundle-type') === 'solo';
        atc.textContent = isSolo
          ? (cfg && cfg.i18n && cfg.i18n.addPerfume) || 'Add perfume to cart'
          : (cfg && cfg.i18n && cfg.i18n.addBundle) || 'Add set to cart';
      }
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
      syncStickyFromBundleCard(card);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    var preset = qs('bundle');
    var presetCard = null;
    if (preset === 'follow' || preset === 'amaze' || preset === 'complete') {
      presetCard = cards.find(function (c) {
        return c.getAttribute('data-bundle-type') === preset && !c.disabled;
      });
    }
    if (presetCard) {
      selectCard(presetCard);
      window.requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      var solo = cards.find(function (c) {
        return c.getAttribute('data-bundle-type') === 'solo' && !c.disabled;
      });
      if (solo) selectCard(solo);
    }

    if (atc) {
      atc.addEventListener('click', function () {
        if (!selected) return;
        var variantId = selected.getAttribute('data-variant-id');
        if (!variantId) return;
        var label = atc.textContent;
        atc.disabled = true;
        atc.textContent = (cfg && cfg.i18n && cfg.i18n.adding) || 'Adding…';
        if (errorEl) {
          errorEl.classList.remove('is-visible');
          errorEl.textContent = '';
        }

        addVariant(variantId, 1)
          .then(function () {
            return fetchCart();
          })
          .then(function (cart) {
            refreshCartDrawer(cart);
            atc.textContent = label;
            atc.disabled = false;
          })
          .catch(function (err) {
            console.error('[yazli-bundles] ATC', err);
            atc.textContent = label;
            atc.disabled = false;
            if (errorEl) {
              errorEl.textContent =
                (err && err.message) ||
                (cfg && cfg.i18n && cfg.i18n.error) ||
                'Error';
              errorEl.classList.add('is-visible');
            }
          });
      });
    }
  }

  /* ——— Cart upgrade helpers (buttons rendered in liquid) ——— */
  function initCartUpsell() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-yazli-bundle-upgrade]');
      if (!btn) return;
      e.preventDefault();

      var removeKey = btn.getAttribute('data-remove-key');
      var addVariantId = btn.getAttribute('data-add-variant');
      if (!addVariantId) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading', 'yazli-loading');
      btn.setAttribute('aria-busy', 'true');

      var chain = Promise.resolve();
      if (removeKey) {
        chain = changeLine(removeKey, 0);
      }

      chain
        .then(function () {
          return addVariant(addVariantId, 1);
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          refreshCartDrawer(cart);
          btn.classList.remove('is-loading', 'yazli-loading');
          btn.removeAttribute('aria-busy');
        })
        .catch(function (err) {
          console.error('[yazli-bundles] upgrade', err);
          btn.disabled = false;
          btn.textContent = original;
          btn.classList.remove('is-loading', 'yazli-loading');
          btn.removeAttribute('aria-busy');
          window.alert((getConfig() && getConfig().i18n && getConfig().i18n.error) || 'Error');
        });
    });
  }

  function boot() {
    initTeaser();
    initPdp();
    initCartUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
